import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { RejectModal } from './RejectModal';
import { primary45 } from '../../../utils/color';
import { approvalPolicy } from '../../../service/todo';
import { encryptStorage } from '../../../constant';

export function RejectDialog({
    isVisible,
    body,
    onClose,
    title,
    noPadding,
    backgroundColor,
    positionTop,
    policyId,
    style
}) {
    const [rejectComments, setRejectComments] = useState("");
    if (!isVisible) {
        return null;
    }

    const styles = {
        header: {
            backgroundColor: primary45,
            color: '#FFF',
            padding: 8,
            fontSize: 14,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        body: {
            backgroundColor: backgroundColor ? backgroundColor : '#FFF',
        },
        xIcon: {
            cursor: 'pointer',
        },
    };

    return (
        <RejectModal onClose={onClose} isVisible={isVisible} positionTop={positionTop}>
            <div style={styles.body}>
                <div class="modal-dialog modal-dialog-centered" >
                    <div style={{ maxWidth: "500px", borderRadius: 4 }} class="modal-content">
                        <div class="modal-header border-0 pb-0">
                            <h5 class="modal-title font-14 bold-text" >Reason for Rejection</h5>
                            <button type="button" onClick={onClose} class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <label class="form-label text-black font-12 bold-text" for="startFrom">Comments<span class="required">*</span></label>
                            <textarea class="form-control cust-input-sty font-14 font-regular"
                                onChange={(e) => { setRejectComments(e.target.value);}}
                                rows="4" style={{ resize: "none" }}></textarea>
                        </div>
                        <div class="modal-footer border-0 text-end pt-0">
                            <button type="button" onClick={onClose}
                                class="btn cancel-button btn-link text-black shadow-none font-14 bold-text px-3 me-3">
                                Cancel
                            </button>
                            <button type="button" onClick={async () => {
                                //PC_FG_80
                                let update = await approvalPolicy({
                                    approverAction: "rejected",
                                    comments: rejectComments,
                                    approverId: encryptStorage.getItem('secAudits') == true ? 
                                                    encryptStorage.getItem('secAudits') : 
                                                        encryptStorage.getItem('employeeId'),
                                    policyId: policyId,
                                })
                                //PC_FG_81.5
                                onClose(update);
                            }}
                                class="btn hive-btn-primary d-inline font-14 font-medium px-4">
                                Reject
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </RejectModal>
    );
}
